import React from 'react';
import PropTypes from 'prop-types';
import Map from './Map';
import ColorSF2 from '../../styles/common/ColorSF2';

const style = {
  main: {
    flex: '1 0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    height: 'calc(100% - 30px)',
    margin: '0px 15px',
    boxShadow: `0px 4px 6px ${ColorSF2.transparentShadow}`,
  },
  gooleMap: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
};

const MapPage = ({
  redirect,
  dispatch,
  operators,
  mapCenterSite,
  fullscreen,
}) => (
  <div style={style.main}>
    <div style={style.gooleMap}>
      <Map
        dispatch={dispatch}
        operators={operators}
        mapCenterSite={mapCenterSite}
        fullscreen={fullscreen}
        onSelectOperator={operatorId => {
          redirect(`/ds/timelinetile/${operatorId}`);
        }}
      />
    </div>
  </div>
);

MapPage.propTypes = {
  redirect: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  operators: PropTypes.array.isRequired,
  mapCenterSite: PropTypes.object.isRequired,
  fullscreen: PropTypes.bool.isRequired,
};

export default MapPage;
